/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormState,
  FormStateSchema,
} from '@gh/builder-shared';
import {
  PRIVILEGED_EP_SYS_VARS_JOBS_DPP,
  PRIVILEGED_EP_SYS_VARS_JOBS_PERMIT_DATE,
} from '@gh/builder-shared-data';
import { NumberTypes, whenEditMode } from '@gh/common-shared';

import { FormMode } from '@gh/core-ui';
import { SystemVarsJob } from '../../../resources/model/system-vars-jobs.model';

@Injectable()
export class SystemVarsJobsCommonSettingsSubTabFormState extends FormState<SystemVarsJob> {
  constructor(schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  build(sysVarsJobs: SystemVarsJob, mode: FormMode): void {
    this.setMode(mode);

    this.initSchema(sysVarsJobs);
  }

  protected buildSchema(_: SystemVarsJob, { root }: FormStateSchema): FormRootSchema {
    return root({
      enabled: whenEditMode(),
      mode: this.mode,
      privilegedEntryPoints: [PRIVILEGED_EP_SYS_VARS_JOBS_DPP, PRIVILEGED_EP_SYS_VARS_JOBS_PERMIT_DATE],
      children: {
        jobLettersAvailable: void 0,
        jobLettersAvailableVersion: void 0,
        dppAllowed: { privileged: PRIVILEGED_EP_SYS_VARS_JOBS_DPP },
        jobShowFinalisedJobsByDefault: void 0,
        jobColorSelectionMemo: void 0,
        jobCsCostCenterClone: void 0,
        jobCsCostCenterRequired: void 0,
        jobUseCodeOfCompliance: void 0,
        jobDelayDays: { required: true, type: NumberTypes.DelayDays },
        jobContractStartBasedOn: { required: true },
        jobContractConstructionPeriodIncludes: { required: true },
        jobChangeOrdersParagraph: void 0,
        jobTimeExtension: { type: NumberTypes.TimeExtension },
        jobSupplierFooter: void 0,
        jobCustomerFooter: void 0,
        useLetterhead: void 0,
        jobNumberOfMonthsAutoFinaliseJob: { required: true },
        jobNumberOfMonthsMakeDppNotProceeding: { required: true },
        jobUseCouncilPermitDate: { privileged: PRIVILEGED_EP_SYS_VARS_JOBS_PERMIT_DATE },
        jobCostCenter1: { privileged: PRIVILEGED_EP_SYS_VARS_JOBS_PERMIT_DATE },
        jobCostCenter2: { privileged: PRIVILEGED_EP_SYS_VARS_JOBS_PERMIT_DATE },
        jobCostCenter3: { privileged: PRIVILEGED_EP_SYS_VARS_JOBS_PERMIT_DATE },
        jobCostCenter4: { privileged: PRIVILEGED_EP_SYS_VARS_JOBS_PERMIT_DATE },
      },
    });
  }
}
